import NavbarComponent from "../components/NavbarComponent";
import SearchBarComponent from "../components/SearchBarComponent";

const CountriesListPage = () => {
  return (
    <>
      <NavbarComponent />
      <SearchBarComponent />
    </>
  );
};

export default CountriesListPage;
